<template>
  <div>
    <Header :navTitle="details.caseName"
     :navTip="`${details.finalCustomer}/${details.caseType}/${details.time}`" />
    <div class="infoBox">
      <div class="title">项目基本信息</div>
      <div class="infoBoxCont">
        <van-cell-group style="width: 100%">
          <van-cell title="案件开始时间" :value="details.startTime" />
          <van-cell title="案件结束时间" :value="details.endTime" />
          <van-cell title="最终客户名称" :value="details.finalCustomer" />
          <van-cell title="客户担当" :value="details.customerPrincipal" />
          <van-cell title="直接客户" :value="details.directCustomer" />
          <van-cell title="项目担当" :value="details.projectPrincipal" />
        </van-cell-group>
      </div>

      <div class="title">我的工时投入情况</div>
      <div class="infoBoxCont">
        <div
          ref="pic"
          style="width: 70%; height: 200px; padding: 10px 0 10px 10px"
        ></div>
        <div class="statistics">
          <div class="text">
            <div>我的累计工时:</div>
            <div>{{ housr.userHour }}人月</div>
            <div class="line"></div>
            <div>案件累计工时:</div>
            <div>{{ housr.totalHour }}人月</div>
          </div>
        </div>
      </div>
      <div class="title"></div>
      <div class="infoBoxCont" style="display: block">
        <!-- <select
          @change="onSelected($event)"
          name=""
          id=""
          style="height: 30px"
          class="select"
        >
          <option v-for="item in yearsList" :key="item">{{ item }}</option>
        </select> -->
        <div style="padding-left:30px;padding-top:10px;">
        <van-popover
            theme="dark"
            v-model:show="showPopover" :actions="yearsList" @select="onSelected">
            <template #reference>
              <van-button  size="small" type="primary">
                {{selectDate}}
              </van-button>
            </template>
          </van-popover>
        </div>
        <div
          ref="bar"
          style="width: 100%; height: 200px; padding: 10px 0 10px 10px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import Header from '@/components/header.vue';
import { defineComponent, ref, onMounted } from 'vue';
import {
  Form,
  CellGroup,
  Cell,
  Popover,
  Button,
} from 'vant';
import { useRoute } from 'vue-router';
import { getInfo, getPic } from '@/http/caseInfo';
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { PieChart, BarChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer,
  LegendComponent,
  BarChart,
]);

const option: any = {
  tooltip: {
    trigger: 'item',
  },
  series: [
    {
      type: 'pie',
      radius: ['50%', '90%'],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 10,
        borderColor: '#fff',
        borderWidth: 2,
      },
      label: {
        show: false,
        position: 'center',
        fontSize: '12',
      },
      emphasis: {
        label: {
          show: true,
          fontSize: '12',
          fontWeight: 'bold',
        },
      },
      labelLine: {
        show: false,
      },
      data: [],
    },
  ],
};
const optionBar = {
  xAxis: {
    type: 'category',
    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  },
  yAxis: {
    type: 'value',
  },
  series: [
    {
      data: [120, 200, 150, 80, 70, 110, 130],
      type: 'bar',
    },
  ],
};
export default defineComponent({
  components: {
    [Form.name]: Form,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Popover.name]: Popover,
    [Button.name]: Button,
    Header,
  },
  setup(props) {
    const route = useRoute();
    const showPopover = ref(false);
    const { projectid } = route.query;
    const details = ref({});
    const pic: any = ref(null);
    const bar: any = ref(null);
    const housr = ref({});
    const yearsList = ref([]);
    const selectDate = ref(new Date().getFullYear());
    getInfo({ id: projectid }).then((res: any) => {
      details.value = res.result.details;
      console.log('dom');
      const dom: HTMLElement = pic.value as HTMLElement;
      const myChart = echarts.init(dom);
      const {
        result: { percent, hours },
      } = res;
      housr.value = hours;
      option.series[0].data = [
        { value: percent.otherPercent, name: '其余工时比例(%)' },
        { value: percent.userPercent, name: '我的工时比例(%)' },
      ];
      myChart.setOption(option);
    });
    const getPicD = (yerar?: any) => {
      getPic({ id: projectid, year: yerar || '' }).then((res: any) => {
        const {
          result: { list, years },
        } = res;
        yearsList.value = years.map((date: any) => ({ text: date }));
        const dom: HTMLElement = bar.value as HTMLElement;
        console.log(bar.value);
        const myChart = echarts.init(dom);
        optionBar.xAxis.data = list.map((item: any) => item.month);
        optionBar.series[0].data = list.map((item: any) => item.hour);
        myChart.setOption(optionBar);
      });
    };
    const onSelected = (value: any) => {
      selectDate.value = value.text;
      getPicD(value.text);
    };
    getPicD();
    return {
      details,
      pic,
      getInfo,
      housr,
      bar,
      yearsList,
      onSelected,
      showPopover,
      selectDate,
    };
  },
});
</script>

<style lang="scss" scoped>
.infoBox {
  padding: 30px 10px 20px 10px;
  .title {
    color: #777778;
    font-size: 14px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .infoBoxCont {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    .select {
      width: 100px;
      margin-top: 8px;
      margin-left: 10px;
    }
    .statistics {
      width: 30%;
      padding: 10px 10px 10px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      .text {
        & > div {
          font-size: 14px;
          color: #858585;
          margin: 5px 0;
        }
      }
      .line {
        height: 1px;
        border-bottom: 1px dashed #ddd;
      }
    }
  }
}
.selectTime {
  display: flex;
  background: #5374e8;
  margin-top: 10px;
  padding: 2px;
  div {
    padding: 10px;
    font-size: 14px;
    border-radius: 5px;
    &.item {
      background: #fff;
      color: #333;
    }
  }
}
</style>
